import { useNavigate } from 'react-router-dom';

export default function Footer() {
  const navigate = useNavigate();

  return (
    <footer className="bg-foreground-950 text-background-50">
      <div className="px-4 md:px-6 py-12 md:py-16 max-w-7xl mx-auto">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
          {/* Column 1 */}
          <div className="lg:col-span-1">
            <h3 className="text-xl md:text-2xl font-heading text-background-50 mb-4">
              Get the Best Deals
            </h3>
            <p className="text-sm text-foreground-400 leading-relaxed">
              Master the <strong className="text-foreground-300">itaobuyspreadsheet</strong> system and transform your shopping experience with data-driven decisions.
            </p>
          </div>

          {/* Column 2 - Quick Links */}
          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4 tracking-wide uppercase">
              Quick Links
            </h4>
            <div className="flex flex-col gap-2.5">
              <a href="/" className="text-sm text-foreground-400 hover:text-background-50 transition-colors whitespace-nowrap">
                Home
              </a>
              <button
                onClick={() => navigate('/article/itaobuyspreadsheet-complete-beginner-guide')}
                className="text-sm text-foreground-400 hover:text-background-50 transition-colors text-left whitespace-nowrap cursor-pointer"
              >
                Guides
              </button>
              <a
                href="https://kaspreadsheet.com"
                target="_blank"
                rel="noopener nofollow"
                className="text-sm text-foreground-400 hover:text-background-50 transition-colors whitespace-nowrap"
              >
                Shop
              </a>
              <button
                onClick={() => navigate('/article/itaobuyspreadsheet-vs-traditional-shopping-lists')}
                className="text-sm text-foreground-400 hover:text-background-50 transition-colors text-left whitespace-nowrap cursor-pointer"
              >
                Compare
              </button>
              <button
                onClick={() => navigate('/article/itaobuyspreadsheet-best-method-smart-shopping')}
                className="text-sm text-foreground-400 hover:text-background-50 transition-colors text-left whitespace-nowrap cursor-pointer"
              >
                Blog
              </button>
            </div>
          </div>

          {/* Column 3 - Follow Us */}
          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4 tracking-wide uppercase">
              Follow Us
            </h4>
            <div className="flex flex-col gap-2.5">
              <a href="#" className="flex items-center gap-2.5 text-sm text-foreground-400 hover:text-background-50 transition-colors whitespace-nowrap">
                <span className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-instagram-line"></i>
                </span>
                Instagram
              </a>
              <a href="#" className="flex items-center gap-2.5 text-sm text-foreground-400 hover:text-background-50 transition-colors whitespace-nowrap">
                <span className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-youtube-line"></i>
                </span>
                YouTube
              </a>
              <a href="#" className="flex items-center gap-2.5 text-sm text-foreground-400 hover:text-background-50 transition-colors whitespace-nowrap">
                <span className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-facebook-line"></i>
                </span>
                Facebook
              </a>
            </div>
          </div>

          {/* Column 4 - Newsletter */}
          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4 tracking-wide uppercase">
              Stay Updated
            </h4>
            <p className="text-xs text-foreground-400 mb-3 leading-relaxed">
              Get the latest <strong>itaobuyspreadsheet</strong> tips and shopping guides delivered to your inbox.
            </p>
            <div className="flex items-center gap-2">
              <input
                type="email"
                placeholder="Your email"
                className="flex-1 bg-foreground-800 border border-foreground-700 rounded-full px-4 py-2 text-sm text-background-50 placeholder:text-foreground-500 focus:outline-none focus:border-foreground-500 transition-colors"
              />
              <button
                type="button"
                className="w-9 h-9 flex items-center justify-center rounded-full bg-secondary-500 text-background-50 hover:bg-secondary-600 transition-colors flex-shrink-0 cursor-pointer"
              >
                <span className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-arrow-right-line text-sm"></i>
                </span>
              </button>
            </div>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="mt-10 md:mt-14 pt-6 border-t border-foreground-800 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-500">
            &copy; {new Date().getFullYear()} itaobuy.homes — Your trusted{' '}
            <strong className="text-foreground-400">itaobuyspreadsheet</strong> resource.
          </p>
          <div className="flex items-center gap-4">
            <a href="/" className="text-xs text-foreground-500 hover:text-foreground-300 transition-colors whitespace-nowrap">
              Privacy Policy
            </a>
            <a href="/" className="text-xs text-foreground-500 hover:text-foreground-300 transition-colors whitespace-nowrap">
              Terms
            </a>
          </div>
        </div>
      </div>

      {/* Background brand text */}
      <div className="pb-8 px-4 overflow-hidden">
        <p className="text-[10vw] md:text-[8vw] font-heading text-foreground-800/15 text-center leading-none select-none">
          ITAOBUY
        </p>
      </div>
    </footer>
  );
}